export const formatNumber = (number: number) => {
  const formattedNumber = new Intl.NumberFormat('tr-TR', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(number)

  return formattedNumber
}
